
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("d5hG9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $986974a658bc51c4$var$_swiper = $986974a658bc51c4$var$_interopRequireDefault((parcelRequire("2mpqL")));

var $5PBbn = parcelRequire("5PBbn");
function $986974a658bc51c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
/**
 * Swiper.js slider initialization
 *
 * options - Swiper.js slider options (optional)
 * @param {Function} callback - callback (optional)
 */ var $986974a658bc51c4$var$init = module.exports.init = function init(callback) {
    var swiperContainers = document.querySelectorAll(".swiper-container.swiper-container--3");
    swiperContainers.forEach(function(swiperContainer) {
        var cID = swiperContainer.getAttribute("id");
        var id = swiperContainer.querySelector(".swiper").getAttribute("id");
        var swiper = new $986974a658bc51c4$var$_swiper["default"]("#".concat(id), {
            modules: [
                $5PBbn.Navigation,
                $5PBbn.Keyboard,
                $5PBbn.A11y
            ],
            speed: 500,
            slidesPerView: 1,
            spaceBetween: 30,
            // setWrapperSize: true,
            loop: true,
            centeredSlides: true,
            watchOverflow: true,
            navigation: {
                nextEl: "#".concat(cID, " .swiper-button-next"),
                prevEl: "#".concat(cID, " .swiper-button-prev")
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true
            },
            on: {
                afterInit: function afterInit() {
                    document.querySelector("#".concat(cID)).classList.add("slider-init");
                }
            }
        });
    });
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$581ff339ea0ba762; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
function $3d624443cd99befe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$4fa2f4023c9cbda5; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=swiper3.module.47d5b69c.js.map
